<template>
  <div class="dragArea">
    <li v-for="el in value" :key="el.id" class="li li-handle">
      <div class="list-container"  @click="$emit('select', el.id)">
        <div class="list-name handle">
          <i class="fa fa-align-justify"></i>
          <span v-if="!isModal" @click="editObject = el">{{ el.name }}</span>
          <span v-else>{{ el.name }}</span>
        </div>
        <div>
          <el-checkbox :value="zoneList.includes(el.id)"/>
        </div>
      </div>
      <nested-draggable :zoneList="zoneList" @select="(e) => $emit('select', e)" :is-modal="isModal" :value="el.objects" :parentId="el.id"/>
    </li>
  </div>
</template>
<script>
import draggable from 'vuedraggable';
import firebase from 'firebase';

export default {
  props: {
    value: {
      type: Array,
    },
    zoneList: Array,
    isModal: Boolean,
    parentId: String,
    isMain: Boolean,
  },
  components: {
    draggable,
  },
  data() {
    return {
      editObject: null,
    };
  },
  methods: {
    fire() {
      return myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
    },
    handleClose() {
      this.editObject = null;
    },
    input(value) {
      this.$emit('input', value);
    },
    change(value) {
      let _value = [...this.value];

      if (value.added) {
        value.added.element.parentId = this.parentId;
        _value[value.added.newIndex] = value.added.element;
      }

      this.$emit('input', _value);
    },
    update() {
      this.$emit('update');
    },
    deleteObject(id) {
      this.$confirm('Вы действительно хотите удалить эту зону?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {

        this.fire()
          .collection('zones')
          .doc(id).delete()
          .then(async () => {
            this.$emit('update');
            this.$notify({
              offset: 60,

              title: 'Успешно!',
              message: 'Раздел удален',
              type: 'success',
            });
          });
      });
    },
  },

  name: 'nested-draggable',
};
</script>
<style scoped lang="scss">
.dragArea {
  min-height: 20px;
  padding: 10px 0 0 0;
  margin-left: 14px;
}

.list-container {
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.2);
  background: #f7f7f7;
  border-radius: 4px;
  min-height: 50px;
  margin-right: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  padding: 0 10px;
  cursor: pointer;
}

.controls {
  display: flex;
  justify-content: space-between;
  width: 50px;
  padding-right: 20px;
  font-size: 22px;
  font-weight: 400;

  .delete {
    font-size: 36px;
    font-weight: 100;
    color: #c0392b;
  }
}

.list-name {
  display: flex;
  align-items: center;
  margin-left: 10px;
}

.drag-handle {
  background: #eee;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  width: 40px;
  margin-left: -10px;
}

.handle {
  i {
    margin-right: 10px;
  }
}

.controls-arrow {
  margin-right: 10px;
  display: flex;
  align-items: center;

  i {
    font-size: 16px;
    margin-right: 10px;
  }
}

.fa-edit {
  margin-left: 8px;
  color: #1e1e21 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Versions/Zone/List.vue